import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsClient = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <div className="flex items-center gap-4">
            <Link to="/signup" className="text-gray-400 hover:text-black transition-colors">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <h1 className="text-xl font-bold tracking-tight">Terms & Conditions for Clients</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl p-6 md:p-8 prose prose-gray max-w-none">
          <p className="text-gray-600 mb-6">By creating an account, you agree to the following:</p>
          
          <p className="text-gray-600 mb-6">
            This platform is a marketplace designed to help organizations discover and connect with independent 
            photographers and videographers ("Creatives"). The platform does not provide creative services and 
            is not a party to any agreement, booking, or transaction between you and a Creative.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Independent Contractors</h2>
          <p className="text-gray-600 mb-6">
            All Creatives on the platform operate as independent contractors. They are not employees, agents, or 
            representatives of the platform. You are solely responsible for managing your working relationship with 
            any Creative you engage, including scope, expectations, and communication.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Bookings & Project Agreements</h2>
          <p className="text-gray-600 mb-6">
            When a booking is created, you and the Creative will confirm project details such as deliverables, 
            timelines, pricing, and revision limits through a shared project agreement. This agreement serves as 
            a mutual scope confirmation between you and the Creative and is not a legal contract provided or 
            enforced by the platform.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Revisions & Satisfaction</h2>
          <p className="text-gray-600 mb-6">
            Each project includes a set number of revisions agreed upon by both parties. If you are not satisfied 
            after the agreed revision limit:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
            <li>You may purchase additional revisions directly from the Creative, or</li>
            <li>You may contact the platform for assistance</li>
          </ul>
          <p className="text-gray-600 mb-6">
            If the platform is asked to review a project, the platform may, at its sole discretion, assess whether 
            the Creative has reasonably fulfilled the agreed scope. If the Creative has met their obligations, you 
            agree to either accept the delivered work or purchase additional revisions. The platform's decision in 
            such cases is final.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Disputes & Refunds</h2>
          <p className="text-gray-600 mb-6">
            The platform is not responsible for creative outcomes, quality, delays, missed deadlines, or project 
            disputes. If a Creative fails to deliver the agreed-upon work, refunds (if applicable) will be issued 
            from funds held in escrow. The platform does not guarantee outcomes and does not assume responsibility 
            for Creative performance.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Payments & Escrow</h2>
          <p className="text-gray-600 mb-6">
            Payments may be processed through a third-party escrow system. The platform does not hold funds for 
            its own benefit and is not responsible for payment disputes beyond facilitating escrow release according 
            to platform rules.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Limitation of Liability</h2>
          <p className="text-gray-600 mb-6">
            To the fullest extent permitted by law, the platform is not liable for any damages, losses, or claims 
            arising from your engagement with a Creative, including but not limited to project outcomes, financial 
            loss, or business interruption.
          </p>

          <h2 className="text-lg font-semibold mt-8 mb-4">Acceptance</h2>
          <p className="text-gray-600">
            By creating an account, you acknowledge that you understand and agree to these terms and that you use 
            the platform at your own discretion and risk.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsClient;
